module.exports = __webpack_public_path__ + "static/media/subOutlook2.8c4c2276.png";